import 'intersection-observer'
import * as React from "react"
import { IOWidget, Updater, fromJSX } from "widgets-for-react"
import { PublicSiteState } from "../../../../../../../root/state"
import { CMSState } from "../../../../cms/blocks/types.gen"




export type MagazineEmbedBlockProps = {
  embed_id: string
}

export type MagazineEmbedBlockStyle = Partial<{
  block_classname: string
  inview_classname: string
  inner_classname: string
  content_classname: string
  iframe_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>


export const MagazineEmbedBlock = (
  props: MagazineEmbedBlockProps,
  options?: { style?: MagazineEmbedBlockStyle; key?: string }
): IOWidget<PublicSiteState, Updater<CMSState>> => (public_state: PublicSiteState) =>
  fromJSX(() => {
    if (document.getElementById('magazine-script-' + props.embed_id) == undefined) {
      let script = document.createElement('script')
      script.src = `https://embed.maglr.com/${props.embed_id}?target=maglr-${props.embed_id}`
      script.type = "text/javascript"
        script.id = 'magazine-script-' + props.embed_id
        document.body.appendChild(script)
      }
      return (
        <div id={`maglr-${props.embed_id}`}></div>
      )
    }
)



